module.exports = __webpack_public_path__ + "img/g0036.09d6893a.png";